;(function ($) {
  "use strict";
  $(document).ready(function () {
    responsiveVideo();
  });

  function responsiveVideo() {
    $('#page-wrapper').fitVids();
  }
})(jQuery);
